export default "__VITE_ASSET__CEDCB75A__"